import * as http from 'node:http';
import * as websocket from 'ws';
import { Http } from './http';

import * as NodeWebStream from 'node:stream/web'

export const createNodeNetwork = (
  http: (typeof import("node:http")),
  stream: (typeof import("node:stream")),
  ws: (typeof import("ws"))
) => {
  
  return {
    /**
     * Convert a Http.Handler function into a function suitable to be
     * passed as a request handler for a NodeJS HttpServer.
     * 
     * @param handler Should not throw an error (it will be unhandled)
     */
    createHttpServerRequestHandler(handler: Http.Handler) {
      return (request: http.IncomingMessage, response: http.ServerResponse) => {
        // need a full URL to invoke the query parser
        const url = new URL(request.url || '/', 'https://example.com');

        const methodsWithBody: string[] = ['POST', 'PUT', 'DELETE']

        handler({
          method: request.method || 'GET',
          headers: request.headers,
          query: Object.fromEntries(url.searchParams.entries()),
          path: url.pathname.slice(1),
          body: methodsWithBody.includes(request.method || 'GET')
            ? stream.Readable.toWeb(request) as ReadableStream<Uint8Array>
            : null,
        })
          .then(handlerResponse => {
            response.statusCode = handlerResponse.status;
            for (const [headerName, headerValue] of Object.entries(handlerResponse.headers))
              if (headerValue)
                response.setHeader(headerName, headerValue)

            if (handlerResponse.body) {
              const readable = stream.Readable.fromWeb(handlerResponse.body as NodeWebStream.ReadableStream)

              readable.pipe(response);
            } else {
              response.end();
              console.log(`No output to write!`)
            }
          })
      }
    },

    createHTTPServer() {},
    createHTTPClient() {},

    createWSServer() {
      const server = new ws.WebSocketServer()
      server.addListener("connection", connection => {
        connection.readyState
      })
    },
    createWSClient() {},
  }
};

